import styled from 'styled-components';
import { color, container, fontSize, screen, spacing } from 'theme';

export const StyledSection = styled.div`
  background-color: ${color('white')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  display: flex;
  flex-direction: column;
  padding: ${spacing('xl4')} ${spacing('md')};
  line-height: 1.5;

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    align-items: center;
    gap: ${spacing('xl2')};
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }

  img {
    width: 50%;
    max-width: 528px;
  }
`;
